const CreateItemIcon = () => {
  return (
    <svg xmlns='http://www.w3.org/2000/svg' width='113' height='95' viewBox='0 0 113 95' fill='none'>
      <path
        d='M55.5775 84.5861C79.2067 84.5861 98.3318 65.6377 98.3318 42.259C98.3318 18.8802 79.2067 0 55.5775 0C32.0176 0 12.8232 18.9484 12.8232 42.3271C12.8232 65.7059 32.0176 84.5861 55.5775 84.5861Z'
        fill='#CAD4D0'
      />
      <path
        d='M76.0149 84.4283C69.5013 84.6328 61.6711 84.4283 56.1276 84.3602C50.6533 84.5647 42.7538 84.6328 36.2402 84.4283C42.6846 80.8159 44.9713 74.0681 45.2484 69.6377H66.8681C67.3531 73.9999 69.6398 80.8159 76.0149 84.4283Z'
        fill='#E6F5EE'
      />
      <g filter='url(#filter0_d_6628_18515)'>
        <path
          d='M96.9418 13.2016V68.888C96.9418 70.3193 95.8331 71.3417 94.5858 71.3417H18.0855C16.7689 71.3417 15.7295 70.2512 15.7295 68.888V13.2016C15.7295 11.9065 16.8382 10.7478 18.0855 10.7478H94.4472C95.9024 10.816 96.9418 11.9065 96.9418 13.2016Z'
          fill='white'
        />
      </g>
      <path
        d='M96.7594 12.8734V61.9424H15.5488V12.8734C15.5488 11.5369 16.686 10.3914 17.9179 10.3914H94.2956C95.717 10.3914 96.7594 11.5369 96.7594 12.8734Z'
        fill='#B7C3C5'
      />
      <path d='M93.8402 13.9224H18.374V59.1178H93.9351V13.9224H93.8402Z' fill='white' />
      <rect x='21.5928' y='17.2014' width='23.3997' height='17.56' fill='#C9D3D0' />
      <rect x='50.5635' y='17.2014' width='38.9995' height='7.13375' fill='#C9D3D0' />
      <rect x='50.5635' y='38.6025' width='38.9995' height='7.13376' fill='#C9D3D0' />
      <rect x='50.5635' y='27.0789' width='38.9995' height='3.2925' fill='#C9D3D0' />
      <rect x='50.5635' y='48.48' width='38.9995' height='3.29251' fill='#C9D3D0' />
      <rect x='21.5928' y='38.6025' width='23.3997' height='17.56' fill='#C9D3D0' />
      <path
        d='M56.197 68.0018C57.3057 68.0018 58.2065 67.1839 58.2065 66.0252C58.2065 64.9347 57.375 64.0486 56.197 64.0486C55.0883 64.0486 54.1875 64.8665 54.1875 66.0252C54.1875 67.1158 55.019 68.0018 56.197 68.0018Z'
        fill='#B7C3C5'
      />
      <path
        d='M7.69554 37.2151C9.2893 37.2151 10.5366 35.9882 10.5366 34.4205C10.5366 32.8529 9.2893 31.626 7.69554 31.626C6.10178 31.626 4.85449 32.8529 4.85449 34.4205C4.85449 35.9882 6.17107 37.2151 7.69554 37.2151Z'
        fill='#C9D3CF'
      />
      <path
        d='M4.85429 28.15C5.8937 28.15 6.79451 27.2639 6.79451 26.2415C6.79451 25.2191 5.8937 24.333 4.85429 24.333C3.81488 24.333 2.91406 25.2191 2.91406 26.2415C2.91406 27.332 3.81488 28.15 4.85429 28.15Z'
        fill='#C9D3CF'
      />
      <path
        d='M106.508 44.2356C108.517 44.2356 110.111 42.6679 110.111 40.6913C110.111 38.7146 108.517 37.147 106.508 37.147C104.498 37.147 102.904 38.7146 102.904 40.6913C102.904 42.6679 104.498 44.2356 106.508 44.2356Z'
        fill='#C9D3CF'
      />
      <path
        d='M68.2732 40.656C67.9914 41.8537 67.5687 43.1218 67.0756 44.1785C65.7371 46.7851 63.6236 48.8281 61.017 50.1667C58.3399 51.5052 55.1697 52.0688 51.9995 51.3643C44.5319 49.8144 39.7413 42.4877 41.2912 35.0201C42.8411 27.5525 50.0974 22.6915 57.565 24.3118C60.242 24.8754 62.5669 26.214 64.5394 28.0456C67.8505 31.3568 69.2595 36.1473 68.2732 40.656Z'
        fill='#1B4332'
      />
      <path
        d='M59.1843 36.6403H56.0141V33.4701C56.0141 32.8361 55.521 32.2725 54.8165 32.2725C54.1824 32.2725 53.6188 32.7656 53.6188 33.4701V36.6403H50.4486C49.8146 36.6403 49.251 37.1335 49.251 37.8379C49.251 38.5424 49.7441 39.0356 50.4486 39.0356H53.6188V42.2058C53.6188 42.8398 54.112 43.4034 54.8165 43.4034C55.4505 43.4034 56.0141 42.9103 56.0141 42.2058V39.0356H59.1843C59.8183 39.0356 60.3819 38.5424 60.3819 37.8379C60.3819 37.1335 59.8183 36.6403 59.1843 36.6403Z'
        fill='white'
      />
      <defs>
        <filter
          id='filter0_d_6628_18515'
          x='0.193562'
          y='2.97984'
          width='112.284'
          height='91.6659'
          filterUnits='userSpaceOnUse'
          colorInterpolationFilters='sRGB'
        >
          <feFlood floodOpacity='0' result='BackgroundImageFix' />
          <feColorMatrix
            in='SourceAlpha'
            type='matrix'
            values='0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0'
            result='hardAlpha'
          />
          <feOffset dy='7.76797' />
          <feGaussianBlur stdDeviation='7.76797' />
          <feColorMatrix type='matrix' values='0 0 0 0 0.397708 0 0 0 0 0.47749 0 0 0 0 0.575 0 0 0 0.27 0' />
          <feBlend mode='normal' in2='BackgroundImageFix' result='effect1_dropShadow_6628_18515' />
          <feBlend mode='normal' in='SourceGraphic' in2='effect1_dropShadow_6628_18515' result='shape' />
        </filter>
      </defs>
    </svg>
  );
};

export default CreateItemIcon;
